export default __webpack_public_path__ + "static/media/file_icon.243f3f3e.svg";